import { Button, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import AsyncBuilder from "components/AsyncBuilder"
import PageContainer from "components/PageContainer"
import { differenceInDays, isAfter } from "date-fns"
import { useState } from "react"
import { pluralize } from "utils/helpers"

import FreeTrialDarkGradient from "../assets/free-trial-gradient-dark.webp"
import FreeTrialLightGradient from "../assets/free-trial-gradient-light.webp"
import SuraasaPlusLogo, { LogoVariant } from "../components/SuraasaPlusLogo"
import { useSuraasaPlusContext } from "../context"
import { getFreeTrialConfig } from "./helper"

const FreeTrialBanner = () => {
  const { subscriptionDetails, initiateSuraasaPlusPurchaseFlow } =
    useSuraasaPlusContext()

  const validThrough = subscriptionDetails?.subscription?.validThrough
  const [now] = useState(() => Date.now())

  if (!subscriptionDetails?.subscription.isFreeClaim || !validThrough)
    return null

  const freeTrialHasEnded = isAfter(now, new Date(validThrough))
  const daysLeft = differenceInDays(new Date(validThrough), new Date())
  const freeTrialIsAboutToEnd = !freeTrialHasEnded && daysLeft <= 3

  const styleConfig = getFreeTrialConfig({
    freeTrialHasEnded: freeTrialHasEnded,
  })

  const title = freeTrialHasEnded
    ? "Your free trial has ended"
    : `Your free trial ends in ${pluralize("day", daysLeft)}`

  if (freeTrialHasEnded || freeTrialIsAboutToEnd)
    return (
      <div className={clsx("relative py-2", styleConfig.background)}>
        <PageContainer>
          <div className="absolute inset-0 -left-10 -top-0 z-0 overflow-hidden md:inset-x-6">
            <img
              className="h-18 w-full md:max-h-15 md:w-auto"
              src={
                freeTrialHasEnded
                  ? FreeTrialDarkGradient
                  : FreeTrialLightGradient
              }
              alt="free-trial"
            />
          </div>
          <div className="relative z-10 flex flex-row gap-2.25">
            <SuraasaPlusLogo
              color={styleConfig.logoColor}
              height={17.18}
              width={36}
              variant={LogoVariant.plus}
            />
            <div className="flex flex-col justify-between sm:w-full sm:flex-row">
              <div className="flex flex-col">
                <Typography
                  variant="title4"
                  className={clsx(styleConfig.titleClassName)}
                >
                  {title}
                </Typography>
                <Typography
                  variant="smallBody"
                  className={clsx(styleConfig.subtitleClassName)}
                >
                  Upgrade now to keep access to all your Suraasa Plus benefits.
                </Typography>
              </div>
              <AsyncBuilder
                handler={async () => await initiateSuraasaPlusPurchaseFlow()}
                render={props => (
                  <Button
                    loading={props.loading}
                    onClick={props.onClick}
                    className={clsx(styleConfig.buttonClassName)}
                  >
                    Get Suraasa Plus
                  </Button>
                )}
              />
            </div>
          </div>
        </PageContainer>
      </div>
    )
}

export default FreeTrialBanner
